import { KlientkontoErklaering } from "../interfaces/api";
import { get, put } from "./util";

export async function getKlientkontoErklaering(id: string) {
  return get<KlientkontoErklaering>({
    query: "Klientkontoerklaering/HentKlientkontoerklaering/" + id,
  });
}

export async function getKlientkontoErklaeringer() {
  return get<KlientkontoErklaering[]>({
    query: "Klientkontoerklaering/HentKlientkontoerklaeringer",
  });
}

/**
 *
 * @param erklering
 * @returns guid of the updated KlientkontoErklaering
 */
export async function putKlientkontoErklaering(
  erklering: Partial<KlientkontoErklaering>,
) {
  return put<string>({
    query: "KlientkontoErklaering",
    body: erklering,
  });
}

/**
 *
 * @param erklaeringId
 * @returns
 */
export async function fjernAlleSigneringer(erklaeringId: string) {
  return put<any>({
    query: "KlientkontoErklaering/FjernAlleSigneringer",
    body: { erklaeringId },
  });
}
